import { stringify } from "query-string";
import axios from "../../../../../resources/js/axios-defaults";
const Get = async ({ endpoint, queryJson }) => {
  let queryString = stringify(queryJson);
  if (queryString) {
      queryString = '?'+queryString;
  }
  try {
    const result = await axios.get(`${endpoint}${queryString}`);
    if (!result || !result.data) {
      console.error("[API/Get]: ERROR: no result");
      return false;
    }
    if (result.errors) {
      console.error("[API/Get]: ERRORS", result.errors);
      return false;
    }
    return result.data;
  } catch (e) {
    console.error("[API/Get]: Failed to fetch", e.message);
    return false;
  }
};

export default Get;
